<template>
  <base-wrapper>
    <base-card class="space-y-4">
      <base-input
        inset
        label="Minimal Omzet Jawa"
        placeholder="1.500.000"
        type="text"
        currency
        v-model="form.min_omzet_jawa"
      />
      <base-input
        inset
        label="Pengali Jawa"
        placeholder="45.000"
        type="text"
        currency
        v-model="form.omzet_pengali_jawa"
      />
      <base-input
        inset
        label="Minimal Omzet Luar Jawa"
        placeholder="2.000.000"
        type="text"
        currency
        v-model="form.min_omzet_luar_jawa"
      />
      <base-button @click="onSave">Simpan</base-button>
    </base-card>

    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import { mapActions } from 'vuex';
import { requestMixin } from '../../../../mixins/request/request';

export default {
  mixins: [requestMixin],
  data() {
    return {
      form: {
        min_omzet_jawa: null,
        omzet_pengali_jawa: null,
        min_omzet_luar_jawa: null,
      },
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async loadSetups() {
      this.loading = true;

      const [res, err] = await this.request(`/api/v1/setups`);

      if (!err) {
        const { min_omzet_jawa, omzet_pengali_jawa, min_omzet_luar_jawa } =
          Object.fromEntries(
            res.data
              .filter((setup) =>
                [
                  'min_omzet_jawa',
                  'omzet_pengali_jawa',
                  'min_omzet_luar_jawa',
                ].includes(setup.attributes.setup_key)
              )
              .map((setup) => [
                setup.attributes.setup_key,
                setup.attributes.setup_value,
              ])
          );

        this.form.min_omzet_jawa = min_omzet_jawa;
        this.form.omzet_pengali_jawa = omzet_pengali_jawa;
        this.form.min_omzet_luar_jawa = min_omzet_luar_jawa;
      }

      this.loading = false;
    },
    async onSave() {
      this.loading = true;

      const [, err] = await this.request(
        `/api/v1/setups/-actions/batch-update`,
        {
          method: 'post',
          data: {
            min_omzet_jawa: this.form.min_omzet_jawa.replace(/\D/gi, ''),
            omzet_pengali_jawa: this.form.omzet_pengali_jawa.replace(/\D/gi, ''),
            min_omzet_luar_jawa: this.form.min_omzet_luar_jawa.replace(/\D/gi, ''),
          },
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });
      } else {
        this.createAlert({
          status: 'success',
          data: 'Setup berhasil disimpan',
        });
      }

      this.loading = false;
    },
  },
  created() {
    this.loadSetups();
  },
};
</script>
